(function () {
  angular.module("ticketco/common/section").component("tcSectionLegend", {
    templateUrl: "sections/legend.html",
  });
})();
